import { TableCell, TableRow, Typography } from '@sanlam-glacier/app-common/components';
import styles from './regulation-28-table.module.scss';
import clsx from 'clsx';
import { ViewFullBreakdownButton } from '../../atoms/view-full-breakdown-button/ViewFullBreakdownButton';
import { ExposureBreaches } from '../../atoms/exposure-breaches-cell/ExposureBreaches';
import { Reg28ClientBreachesResponseModelMock } from '../../../types/regulation-28/regulation-28.interfaces';
type Regulation28TableProps = {
  row: Reg28ClientBreachesResponseModelMock;
};

export const Regulation28TableRow = ({ row }: Regulation28TableProps) => {
  const testComponentName = 'regulation28TableRow';

  const firstTwoBreaches = row.exposureBreaches.slice(0, 2);
  const restOfBreaches = row.exposureBreaches.slice(2);

  return (
    <TableRow
      data-testid={`${testComponentName}InfoFor${row.clientName}`}
      className={styles.tableRows}
      key={row.clientId}
    >
      <TableCell className={styles.tableCells} align={TableCell.ALIGN.LEFT}>
        <Typography
          data-testid={`${testComponentName}ClientName`}
          variant={Typography.VARIANT.B4}
          color={Typography.COLOR.PRIMARY}
        >
          {row.clientName}
        </Typography>
      </TableCell>
      <TableCell className={styles.tableCells} align={TableCell.ALIGN.LEFT}>
        <Typography data-testid={`${testComponentName}ClientId`} variant={Typography.VARIANT.B4}>
          {row.clientId}
        </Typography>
      </TableCell>
      <TableCell className={styles.tableCells} align={TableCell.ALIGN.LEFT}>
        <Typography data-testid={`${testComponentName}ProductType`} variant={Typography.VARIANT.B4}>
          {row.productType}
        </Typography>
      </TableCell>
      <TableCell className={styles.tableCells} align={TableCell.ALIGN.RIGHT}>
        <Typography
          data-testid={`${testComponentName}TotalDaysNonCompliant`}
          align={Typography.ALIGN.RIGHT}
          variant={Typography.VARIANT.B4}
        >
          {row.totalDaysNonCompliant}
        </Typography>
      </TableCell>
      <TableCell className={clsx(styles.tableCells)} align={TableCell.ALIGN.LEFT}>
        <ExposureBreaches
          data-testid={`${testComponentName}ExposureBreachesForClient${row.clientName}`}
          firstBreaches={firstTwoBreaches}
          restOfBreaches={restOfBreaches}
        />
      </TableCell>
      <TableCell className={styles.tableCells} align={TableCell.ALIGN.LEFT}>
        <ViewFullBreakdownButton
          clientName={row.clientName}
          exposureBreaches={row.exposureBreaches}
          exposureBreakdown={row.exposureBreakdown}
          buttonText='View full breakdown'
        />
      </TableCell>
    </TableRow>
  );
};
